import React, { useEffect, useState } from 'react';
import Modal from '@/components/atomics/Modal';
import ActionsConfirm from '@/components/molecules/Actions/Confirm';
import Spinner from '@/components/atomics/Spinner';
import ActionsMessage from '@/components/molecules/Actions/Message';
import FeedbackData, { FeedbackFormData } from '@/types/Feedback';
import FeedbackForm from '@/components/molecules/Actions/Feedback/Form';
import { useEditFeedback } from '@/hooks/useFeedback';

const className = 'dashboard-action';

type DashboardActionProps = {
  feedback?: FeedbackData;
  onCancel?: () => void;
  onSubmit?: () => void;
};

const DEFAULT_FORM: FeedbackFormData = {
  feedbackCurrentId: '',
  reviewStatus: '',
  reviewNote: ''
};

const FeedbackAction: React.FC<DashboardActionProps> = ({ feedback, onSubmit, onCancel }) => {
  const [contentModal, setContentModal] = useState<React.ReactNode>();
  const [formData, setFormData] = useState<FeedbackFormData>(DEFAULT_FORM);
  const [isLoading, setIsLoading] = useState(false);
  const { data, error, isLoading: isLoadingFetch, refetch } = useEditFeedback(formData);

  useEffect(() => {
    return () => {
      setContentModal(false);
      setFormData(DEFAULT_FORM)
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    setContentModal(
      <Modal close={false} open={true} onClose={() => setContentModal(undefined)}
        title={''}>
        <ActionsMessage
          message="Status berhasil disimpan."
          title="Update Status"
          onConfirm={() => {
            setIsLoading(false);
            if (onSubmit) {
              onSubmit();
            }
          }}
        />
      </Modal>
    )
  }, [data]);

  useEffect(() => {
    if (error?.message && !isLoadingFetch) {

      setContentModal(
        <Modal close={false} open={true} onClose={() => setContentModal(undefined)}
          title={''}>
          <ActionsConfirm
            confirmTitle="Coba Lagi"
            message={error?.message || ''}
            title="Gagal Menyimpan"
            onConfirm={() => {
              setIsLoading(true);
              refetch();
            }}
            onCancel={() => {
              setContentModal(undefined);
              setIsLoading(false);
            }}
          />
        </Modal>);
    }
  }, [error]);

  useEffect(() => {
    if (isLoading) {
      setContentModal(
        <Modal close={false} open={true} onClose={() => setContentModal(undefined)}
          title={''}>
          <Spinner />
        </Modal>
      );
    }
  }, [isLoading]);

  useEffect(() => {
    if (formData?.feedbackCurrentId) {
      refetch();
    }

    if (!isLoading) {
      setContentModal(
        <Modal close={!isLoading} open={true} onClose={() => setContentModal(undefined)}
          title={!isLoading ? 'Detail Status' : ''}>
          {(feedback && !isLoading) && (
            <FeedbackForm
              feedback={feedback}
              onCancel={() => {
                setContentModal(undefined);
                if (onCancel) {
                  onCancel();
                }
              }}
              onSubmit={(data) => {
                setFormData(data);
                setIsLoading(true);
                // setContentModal(undefined);
              }}
            />
          )}
        </Modal>
      );
    }
  }, [feedback, formData]);

  return (
    <>
      {contentModal}
    </>
  );
};

export default FeedbackAction;
